<template>
  <div class="headbar" :style="{ background: themeColor }">
    <!-- logo -->

    <div
      class="logo"
      :style="{ background: themeColor }"
      @click="$router.push('/')"
    >
      <div>
        <img src="@/assets/logo_blue_new.png" />
        <span>淘宝店铺管理专家</span>
      </div>
    </div>
    <div class="divider"><el-divider direction="vertical"></el-divider></div>
    <!-- 导航菜单 -->
    <div class="navbar">
      <el-menu
        :default-active="topTabsActiveName"
        class="el-menu-demo"
        :background-color="themeColor"
        active-text-color="#409EFF"
        mode="horizontal"
        @select="selectNavBar"
      >
        <el-menu-item index="home" indexPath="/" :router="true">{{
          $t("common.home")
        }}</el-menu-item>
        <el-menu-item index="notice" indexPath="/content" :router="true">
          最近通知</el-menu-item
        >
        <el-menu-item index="class" indexPath="/content" :router="true">
          大学堂
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <el-menu
        class="el-menu-demo"
        :background-color="themeColor"
        text-color="#409EFF"
        mode="horizontal"
      >
        <!-- 系统通知 -->
        <el-menu-item index="4" v-popover:popover-notice>
          <el-badge :value="unReadNotice" :max="99" class="badge">
            <li class="fa fa-bell-o fa-lg"></li>
          </el-badge>
          <el-popover
            ref="popover-notice"
            placement="bottom-end"
            trigger="click"
          >
            <notice-panel></notice-panel>
          </el-popover>
        </el-menu-item>

        <el-menu-item index="5" v-popover:popover-personal>
          <!-- 用户信息 -->
          <span class="user-info"><img :src="edzUser.avatar" /> </span>
          <el-popover
            ref="popover-personal"
            placement="bottom-end"
            trigger="click"
            :visible-arrow="false"
          >
            <personal-panel :user="edzUser"></personal-panel>
          </el-popover>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hamburger from "@/components/Hamburger";
import ThemePicker from "@/components/ThemePicker";
import NoticePanel from "@/views/Core/NoticePanel";
import PersonalPanel from "@/views/Core/PersonalPanel";
export default {
  name: "HeadBar",
  components: {
    Hamburger,
    ThemePicker,
    NoticePanel,
    PersonalPanel
  },
  data() {
    return {
      edzUser: {},
      langVisible: false,
      themeColor: "#FFFFFF"
      //activeIndex: "home"
    };
  },
  methods: {
    selectNavBar: function(index, indexPath) {
      if (index == "home") {
        this.$router.push("/");
      } else if (index == "notice") {
        this.$router.push({ path: `/content/${index}` });
      } else if (index == "class") {
        this.$router.push({ path: `/content/${index}` });
      }
      this.topTabsActiveName = index.toLowerCase();
    }
  },
  mounted() {
    const edzUser = JSON.parse(sessionStorage.getItem("edzUser"));

    if (edzUser) {
      this.edzUser = edzUser;
      if (edzUser != null && (edzUser.avatar == null || edzUser.avatar == "")) {
        this.edzUser.avatar = require("@/assets/user.png");
      }
    }
    //设置选中top菜单
    if (this.$route.params.type) {
      this.topTabsActiveName = this.$route.params.type;
    }
  },
  computed: {
    ...mapState({
      unReadNotice: state => state.user.unReadNotice
    }),
    topTabsActiveName: {
      get() {
        return this.$store.state.tab.topTabsActiveName;
      },
      set(val) {
        this.$store.commit("updateTopTabsActiveName", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.headbar {
  top: 0;
  z-index: 1030;
  height: 60px;
  line-height: 60px;
  border-color: rgba(180, 190, 190, 0.8);
  border-left-width: 1px;
  border-left-style: solid;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  // border-bottom-width: 0.5px;
  // border-bottom-style: solid;
  // margin-bottom: 10px;
  .logo {
    float: left;
    top: 0px;
    height: 60px;
    //line-height: 60px;
    cursor: pointer;
    width: 280px;
    img {
      // width: 40px;
      height: 40px;
      border-radius: 0px;
      margin: 8px 0px 10px 10px;
      float: left;
    }
    div {
      font-size: 16px;
      // color: white;
      span {
        text-align: left;
        padding-left: 20px;
      }
    }
  }
  .divider {
    float: left;
  }
  .navbar {
    float: left;
  }
  .toolbar {
    float: right;
    .user-info {
      font-size: 16px;
      // color: #fff;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        margin: 10px 0px 10px 10px;
        float: right;
      }
    }
  }
}

.badge {
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/HeadBar2.vue